import { requestHandler } from '../../../utils/api';
import { AssignmentDetails } from '../assignmentType';

export const fetchTurnitinLaunchRequest = async ({
  assignmentDetails,
  ltiConsumerEndpoint,
  spaceId,
  userId,
}: {
  assignmentDetails: AssignmentDetails;
  ltiConsumerEndpoint: string;
  spaceId: string;
  userId: string;
}) => {
  if (!assignmentDetails) {
    return null;
  }
  const { id, endDate: dueDate, startDate, title } = assignmentDetails;

  const { data } = await requestHandler({
    url: `${ltiConsumerEndpoint}`,
    method: 'post',
    userId,
    data: {
      assignmentId: id,
      startDate,
      dueDate,
      title,
      spaceId,
    },
  });

  if (data?.errors?.length > 0) {
    console.error(data.errors[0]);
  }

  return data;
};
